// 测试环境破解版
import { DomainGroupConfig, FieldType } from "@/pages/documentCompile/type";

// 使用环境变量配置
const { NODE_STAGE } = process.env;
export const ONLYOFFICE_HOST = NODE_STAGE === 'qa' ? 'http://192.168.13.140:8090/' : process.env.VITE_ONLYOFFICE_HOST;
export const CALLBACK_URL = process.env.VITE_CALLBACK_URL;
export const DOC_URL = process.env.VITE_DOC_URL;
export const EXCEL_URL = process.env.VITE_EXCEL_URL;

console.log("ONLYOFFICE_HOST", ONLYOFFICE_HOST)

// 文档种的 tag 格式
// 名称@类型@挂载类型@实例id (没有挂载类型就是空，)
// 比如 checkbox: isAgree@checkbox@@1 

// 域配置数据 - 这是源数据，定义了有哪些域以及它们的属性
export const domainConfig: DomainGroupConfig[] = [
  {
    fieldTag: "personal",
    fieldName: "项目信息",
    fields: [
      {
        fieldTag: "name",
        fieldName: "工程项目(文本域)",
        fieldType: FieldType.SHORT_TEXT,
        key: "name",
        isEnable: true,
        placeholder: "请输入工程项目",
        tip: "请输入您的工程项目",
        defaultValue: "",
      },
      {
        fieldTag: "projectType",
        fieldName: "项目类别(下拉域)",
        key: "projectType",
        fieldType: FieldType.DROPDOWN,
        isEnable: true,
        content: {
          options: [
            { label: "类别1", value: "type1" },
            { label: "类别2", value: "type2" },
          ]
        },
        placeholder: "请选择项目类别",
        defaultValue: "type1",
      },
      // checkbox 单选互斥域
      {
        fieldTag: "isAgree",
        fieldName: "是否超过 1000 万(单选框域)",
        fieldType: FieldType.SINGLE_CHECKBOX,
        key: "isAgree",
        defaultValue: false,
        isEnable: true,
        value: [0],
        // 内容设置
        content: {
          options: [
            {
              value: 0,
              label: "超过了 1000 万 ${name} ，aa",
            },
            {
              value: 1,
              label: "未超过 1000 万",
            },
            { value: 2, label: "正好 1000 万" }, // 新增选项
            { value: 3, label: "暂未确定" }, // 新增选项
          ],
          // 第一个和第二个 checkbox 是否换行
          isNewLine: true,
        },
      },
      {
        fieldTag: "boxs",
        fieldName: "项目子类型(复选框域)",
        fieldType: FieldType.CHECKBOX,
        key: "boxs",
        defaultValue: false,
        isEnable: true,
        // 内容设置
        content: {
          options: [
            {
              value: 0,
              label: "子类型1",
            },
            {
              value: 1,
              label: "子类型2",
            },
          ],
          // 第一个和第二个 checkbox 是否换行
          isNewLine: true,
        },
      },
      // 日期域，短日期域 2025.06.24
      {
        fieldTag: "projectDateShort",
        fieldName: "日期(短日期域)",
        fieldType: FieldType.DATE_SHORT,
        key: "projectDateShort",
        defaultValue: "",
        isEnable: true,
        // 日期格式
        dateFormat: 'yyyy.mm.dd',
      },
      // 日期域，长日期域 2025年06月24日
      {
        fieldTag: "projectDateLong",
        fieldName: "日期(长日期域)",
        fieldType: FieldType.DATE_LONG,
        key: "projectDateLong",
        defaultValue: "",
        isEnable: true,
        // 日期格式
        dateFormat: 'yyyy年mm月dd日',
      },
      // 图片域
      {
        fieldTag: "proejctImage",
        fieldName: "项目图片(图片域)",
        fieldType: FieldType.IMAGE,
        key: "proejctImage",
        defaultValue: "",
        isEnable: true,
      },
    ],
  },
];
